import React, { Fragment, useEffect, useState } from 'react'
import styled from '@emotion/styled'

import { fontSizeSmall, fontSizeXSmall, fontSize3XSmall, fontWeightBold, fontWeightRegular, grayLight30 } from '../../constants/principles'
import { BrowserUtils, QuestionUtils } from '../../utils/siteUtils'
import { FlexDiv } from '../generic/Basics'
import Spinner from '../generic/spinner.js'

export default ({ svgItems, bodyStyle, setShowModal, height = '175px', width = '400px', addMolding = false, conditionQuestions = [], anyAnswered, children }) => {
  const [allSvgs, setAllSvgs] = useState()
  const isDesktop = BrowserUtils.isDesktop()
  const subsectionCodes = Array.from(
    conditionQuestions.reduce((acc, question) => {
      return acc.add(question.subsectionCode)
    }, new Set())
  ).filter(item => !!item)

  const onClick = nameOverride => (name, state, toggle) => {
    const [subsection, item] = name.split('|')
    const subsectionCode = subsectionCodes.find(code => (nameOverride || subsection).toLowerCase().includes(code.toLowerCase()))
    setShowModal({
      name: item,
      subsectionCode,
      onChange: anyTrue => {
        toggle && toggle(anyTrue)
      }
    })
  }

  useEffect(() => {
    import('../compiledSVG/condition/Convertible').then(Module => {
      setAllSvgs(x => ({ ...x, Convertible: Module }))
    })
    import('../compiledSVG/condition/Coupe').then(Module => {
      setAllSvgs(x => ({ ...x, Coupe: Module }))
    })
    import('../compiledSVG/condition/Generic').then(Module => {
      setAllSvgs(x => ({ ...x, Generic: Module }))
    })
    import('../compiledSVG/condition/Hatchback').then(Module => {
      setAllSvgs(x => ({ ...x, Hatchback: Module }))
    })
    import('../compiledSVG/condition/Sedan').then(Module => {
      setAllSvgs(x => ({ ...x, Sedan: Module }))
    })
    import('../compiledSVG/condition/Suv').then(Module => {
      setAllSvgs(x => ({ ...x, Suv: Module }))
    })
    import('../compiledSVG/condition/Truck').then(Module => {
      setAllSvgs(x => ({ ...x, Truck: Module, Pickup: Module }))
    })
    import('../compiledSVG/condition/Van').then(Module => {
      setAllSvgs(x => ({ ...x, Van: Module, Passenger: Module }))
    })
    import('../compiledSVG/condition/Wagon').then(Module => {
      setAllSvgs(x => ({ ...x, Wagon: Module }))
    })
  }, [])

  const svgs = allSvgs && allSvgs[bodyStyle] ? svgItems.map(item => allSvgs[bodyStyle][item] || allSvgs[bodyStyle][item.slice(0, -1)]) : null
  const Moulding = allSvgs && allSvgs.Generic ? allSvgs.Generic.Molding : null

  return svgs ? (
    svgs.map((Svg, index) => {
      const representativeQuestion = conditionQuestions.find(question => question.subsectionCode && svgItems && svgItems[index].toLowerCase().includes(question.subsectionCode))
      const title = representativeQuestion && representativeQuestion.subsection
      const subtitle = representativeQuestion && representativeQuestion.subsectionDescription.split('\\n')
      const curState =
        representativeQuestion &&
        QuestionUtils.getItems(conditionQuestions, representativeQuestion.subsectionCode)
          .map(item => ({
            [item]: anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, item, representativeQuestion.subsectionCode))
          }))
          .reduce((acc, cur) => {
            acc[Object.keys(cur)[0]] = Object.values(cur)[0]
            return acc
          }, {})

      return (
        <Fragment key={index}>
          <StyledH1 isDesktop={isDesktop}> {title}</StyledH1>
          <StyledH3>
            {subtitle && subtitle[0]} <br /> {subtitle && subtitle[1]}
          </StyledH3>
          <SpacedDiv>
            {Svg && <Svg height={isDesktop ? height + 'px' : height * 0.75 + 'px'} width={isDesktop ? width + 'px' : width * 0.75 + 'px'} {...curState} onClick={(...args) => onClick()(...args)} />}
            {addMolding && Svg && Moulding && (
              <Moulding width={isDesktop ? '150px' : '120px'} height="40px" molding={curState && curState.moldingtrim} onClick={(...args) => onClick(svgItems && svgItems[index])(...args)} name={svgItems && svgItems[index]} />
            )}
            {children}
          </SpacedDiv>
        </Fragment>
      )
    })
  ) : (
    <Spinner />
  )
}

const SpacedDiv = styled(FlexDiv)`
  padding-bottom: 40px;
  margin-bottom: 40px;
  border-bottom: 1px solid ${grayLight30};
  &:last-child {
    margin-bottom: 0px;
    padding-bottom: 0px;
    border-style: none;
  }
`
const StyledH1 = styled.h1`
  font-size: ${p => (p.isDesktop ? fontSizeSmall : fontSizeXSmall)};
  font-weight: ${fontWeightBold};
  margin-top: 0px;
  margin-bottom: 1px;
`
const StyledH3 = styled.h3`
  font-size: ${fontSize3XSmall};
  font-weight: ${fontWeightRegular};
  margin: 1px 0 12px 0;
`
